'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasr';
var iconName = 'flask-round-potion';
var width = 384;
var height = 512;
var aliases = ["flask-potion"];
var unicode = 'f6e1';
var svgPathData = 'M296 0l-232 0 0 48 32 0 0 105.7C38.6 186.9 0 248.9 0 320 0 426 86 512 192 512s192-86 192-192c0-71.1-38.6-133.1-96-166.3l0-105.7 32 0 0-48-24 0zM144 168.2l0-120.2 96 0 0 135.3 13.7 6.5C302.4 213 336 262.6 336 320l-35.7 0c-24.6 0-48.8-6.7-70-19.4l-5-3c-28-16.8-60-25.6-92.6-25.6-27.9 0-55.5 6.5-80.5 19l-1.6 .8c9-45.1 39-82.7 79.5-101.9l13.7-6.5 0-15.2zM50.3 345.7l23.5-11.8c18.3-9.2 38.5-13.9 59-13.9 23.9 0 47.4 6.5 67.9 18.8l5 3C234.2 358.9 267 368 300.3 368l27.5 0c-19.8 55.9-73.1 96-135.8 96-70.8 0-129.6-51-141.7-118.3z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faFlaskRoundPotion = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;